import "./moods.css";

// The warm streak card from the check-in design: a gently animated flame
// beside the running day count. Purely a display of /engagement/streak.
export default function StreakFlame({ days = 0 }) {
  return (
    <div className="mf-streak" aria-label={`${days} day streak`} data-testid="checkin-streak">
      <svg className="mf-streak-flame" viewBox="0 0 40 48" fill="none" aria-hidden="true">
        <path d="M20 2C28 14 38 18 33 32c-2 8-7 12-13 12S9 40 7 32C3 18 12 14 20 2Z" fill="#F5841F" />
        <path d="M20 15c5 8 10 10 7 19-1.6 5-4.4 7-7 7s-5.4-2-7-7c-3-9 2-11 7-19Z" fill="#FDBA5B" />
      </svg>
      <div>
        <div className="mf-streak-num">{days}</div>
        <div className="mf-streak-label">Day Streak</div>
      </div>
    </div>
  );
}
